export const TENANT_ENDPOINT = {
  detail: `${import.meta.env.VITE_APP_API}/tenants/get-tenant`,
  list: `${import.meta.env.VITE_APP_API}/tenants/get-tenants`,
  getOwnersOfTenant: `${import.meta.env.VITE_APP_API}/owners/get-owners`,
  archive: `${import.meta.env.VITE_APP_API}/tenants/archive-tenant`,
  delete: `${import.meta.env.VITE_APP_API}/tenants/delete-tenant`,
  toggleStatus: `${
    import.meta.env.VITE_APP_API
  }/tenants/activate-or-block-tenant`,
  bulkToggleStatus: `${
    import.meta.env.VITE_APP_API
  }/tenants/bulk-activate-or-block-tenant`,
  restore: `${import.meta.env.VITE_APP_API}/tenants/restore-tenant`,
  archivedTenants: `${
    import.meta.env.VITE_APP_API
  }/tenants/get-archived-tenants`,
  archivedTenant: `${import.meta.env.VITE_APP_API}/tenants/get-archived-tenant`,
  create: `${import.meta.env.VITE_APP_API}/tenants/create-tenant`,
  update: `${import.meta.env.VITE_APP_API}/tenants/update-tenant`,
  updateProfile: `${
    import.meta.env.VITE_APP_API
  }/tenants/update-tenant-profile-image/`,

  export: `${import.meta.env.VITE_APP_API}/tenants/export-tenants`,
  import: `${import.meta.env.VITE_APP_API}/tenants/import-tenants`,
}
